/* eslint-disable class-methods-use-this */
import { ReportGrammarRules } from '../../../../../../../redux/config/customReport/types'
import { NodesById, NormalizedBuilderNode, State, VisitorContext } from '../types'
import { NormalizedAbstractVisitor } from './NormalizedAbstractVisitor'
import { TitleSegment, getCategoryOwnSegments } from '../../../print/CategoryTitleVisitor'

export class NormalizedTitleVisitor extends NormalizedAbstractVisitor<TitleSegment[]> {
  constructor(rules: ReportGrammarRules, nodesById: NodesById) {
    super(rules, nodesById, true)
  }

  public getTitleSegments(nodeId: string): TitleSegment[] {
    return this.visitNodeById(nodeId, { state: State.Root }, true).filter(s => s.text)
  }

  public getPlainTitle(nodeId: string): string {
    return this.getTitleSegments(nodeId)
      .map(s => s.text)
      .join('\n')
      .trim()
  }

  protected visitNodeById(nodeId: string, context: VisitorContext, isRoot = false): TitleSegment[] {
    const node = this.nodesById[nodeId]
    if (!node) return []

    if (node.type === 'reference') {
      const refId = node.value as string
      if (!refId || !this.nodesById[refId]) return []
      return this.visitNodeById(refId, context)
    }

    const segments: TitleSegment[] = [...getCategoryOwnSegments(node)]

    const shouldTraverseChildren = isRoot ? node.type === 'function' : true
    if (shouldTraverseChildren) {
      for (const childId of node.childIds || []) {
        segments.push(...this.visitNodeById(childId, context))
      }
    }

    return segments
  }

  visitRootNode(node: NormalizedBuilderNode): TitleSegment[] {
    return getCategoryOwnSegments(node)
  }

  visitCompanyNode(node: NormalizedBuilderNode): TitleSegment[] {
    return getCategoryOwnSegments(node)
  }

  visitDimensionNode(node: NormalizedBuilderNode): TitleSegment[] {
    return getCategoryOwnSegments(node)
  }

  visitPeriodGroupNode(node: NormalizedBuilderNode): TitleSegment[] {
    return getCategoryOwnSegments(node)
  }

  visitFunctionNode(node: NormalizedBuilderNode): TitleSegment[] {
    return getCategoryOwnSegments(node)
  }

  visitReferenceNode(_node: NormalizedBuilderNode): TitleSegment[] {
    return []
  }

  visitKeyFigureNode(node: NormalizedBuilderNode): TitleSegment[] {
    return getCategoryOwnSegments(node)
  }

  visitFormulaNode(node: NormalizedBuilderNode): TitleSegment[] {
    return getCategoryOwnSegments(node)
  }
}
